/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class Campaignservicev1Dependency {
    'dependencyName'?: string;
    'responsive'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "dependencyName",
            "baseName": "dependencyName",
            "type": "string",
            "format": ""
        },
        {
            "name": "responsive",
            "baseName": "responsive",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Campaignservicev1Dependency.attributeTypeMap;
    }

    public constructor() {
    }
}

